import { apiClient } from "../api";
import { CreateNewsDto, News, UpdateNewsDto } from "../generated/client";

export const createNews = async (data: CreateNewsDto): Promise<News> => {
    try {
        const response = await apiClient.news.create(data);
        return response.data;
    } catch (error) {
        console.error("create news:", error);
        throw error;
    }
};

export const getAllNews = async (): Promise<Array<News>> => {
    try {
        const response = await apiClient.news.findAll();
        return response.data;
    } catch (error) {
        console.error("fetch news:", error);
        throw error;
    }
};

export const getNewsById = async (id: string): Promise<News> => {
    try {
        const response = await apiClient.news.findOne(id);
        return response.data;
    } catch (error) {
        console.error(`fetch news by ID ${id}:`, error);
        throw error;
    }
};

export const updateNews = async (id: string, data: UpdateNewsDto): Promise<News> => {
    try {
        const response = await apiClient.news.update(id, data);
        return response.data;
    } catch (error) {
        console.error(`update news by ID ${id}:`, error);
        throw error;
    }
};

export const removeNews = async (id: string): Promise<void> => {
    try {
        await apiClient.news.remove(id);
    } catch (error) {
        console.error(`removing news by ID ${id}:`, error);
        throw error;
    }
};
